module.exports = __webpack_public_path__ + "static/income_xa.cba995f7.png";